<template>
  <div>
    <div class="flex-default">
      <div style="flex:1">
        <div>
          <span> {{ data.name }}</span>
          <span style="font-size: 12px;">
            ({{ data.qrcode }})
          </span>
        </div>


      </div>
      <el-popover v-model="popoverVisible" placement="top-start" width="300" trigger="hover"
        popper-class="c-el-popover-blue opacity-1">
        <span slot="reference" style="margin-left: 6px;">
          <i class="iconfont icon-dingwei" style="flex-shrink:0"></i>
        </span>

        <div v-if="popoverVisible" style="height: 300px;" @click.stop>
          <MapContainer ref="mapContainer" :showBottom="false" :showSearch="false" :zoomToolConfig="zoomToolConfig">
            <template slot="openlayer">
              <LMarker :positionVal="markerCoords" :zIndex="30" :imgUrl="markerImage" />
            </template>
          </MapContainer>
        </div>

      </el-popover>

    </div>

  </div>
</template>

<script>
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import { LMarker } from '@OpenLayersCommon'
export default {
  components: {
    MapContainer,
    LMarker
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          // "id": "515",
          // "name": "半月岛方舱位置",
          // "parentId": "0",
          // "longitude": "113.1598211",
          // "latitude": "23.0005485",
          // "altitude": "-1.7",
          // "qrcode": "UAT-01",
          // "remark": null
        }
      },
    },
  },

  data() {
    return {
      popoverVisible: false,
      zoomToolConfig: {
        showViewMode: false, // 是否显示2D,3D切换按钮
        showMeasure: false, // 是否显示测量按钮
        showFullScreen: true, // 是否显示全屏按钮
        showResetView: false, // 是否显示重置按钮
        showCampass: false, // 是否显示旋转按钮
        showZoomIn: false, // 是否显示放大按钮
        showZoomOut: false, // 是否显示缩小按钮
        showSwitchMapLayer: true, // 是否显示切换地图底图按钮
      },
      markerImage: require('../../../imgs/location.png'),
    };
  },
  computed: {
    markerCoords() {
      let coord = []
      if (this.data.longitude && this.data.latitude) {
        coord = [
          this.data.longitude,
          this.data.latitude,
        ]
      }
      return coord

    }
  },
  methods: {
    toCenter() {
      setTimeout(() => {
        if (this.$refs.mapContainer) {
          if (this.data.longitude && this.data.latitude) {
            this.$refs.mapContainer.toCenter([
              this.data.longitude,
              this.data.latitude,
            ])
          }
          this.$refs.mapContainer.toMapZoom(15)
        }
      }, 100)
    }
  },
  mounted() { },
  watch: {
    data: {
      handler(newVal) {
        if (newVal.longitude && newVal.latitude) {

          this.toCenter();


        }
      },
      immediate: true,
      deep: true
    },
    popoverVisible(newVal) {
      if (newVal) {
        this.toCenter();
      }
    }
  }
};
</script>


<style lang="scss" scoped></style>